import {fetchBody, URL_PAGE_GETPAGEID} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";


export function api_getPageId ({mReqPageId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPageId, token}), 
      url: URL_PAGE_GETPAGEID, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}
